import {Component, Input, Output, EventEmitter, HostBinding} from '@angular/core';

@Component({
  selector: 'app-switcher',
  templateUrl: './switcher.component.html',
  styleUrls: ['./switcher.component.scss']
})
export class SwitcherComponent {
  @Input() value: boolean;
  @Output() toggle = new EventEmitter<boolean>();

  @HostBinding('class.horizontal')
  @Input() isHorizontal: boolean;
}
